// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__lG2cB","gfeWrapper":"CalendarEvent_gfeWrapper__2Fc8L"};